<div class="card">
  <!-- Card Header -->
  <div class="px-4 py-3 border-b">
    <h3 class="text-lg font-semibold">Branch</h3>
  </div>

  <!-- Card Body -->
  <div class="p-4">
    <kendo-grid
      [kendoGridBinding]="repState.branches"
      [pageSize]="20"
      [pageable]="true"
      (edit)="editHandler($event)"
      (add)="addHandler($event)"
      (save)="saveHandler($event)"
      (cancel)="cancelHandler($event)"
    >
      <ng-template kendoGridToolbarTemplate>
        <button
          type="button"
          (click)="buttonclicked()"
          icon="plus-outline"
          look="flat"
          kendoGridAddCommand
        >
          Add New Record
        </button>
        <button
          type="button"
          icon="refresh-sm"
          look="flat"
          kendoButton
          class="display-end"
        >
          Refresh
        </button>
      </ng-template>
      <kendo-grid-column
        *ngIf="!hiderow"
        width="200"
        field="branchCode"
        title="Branch Code"
        [editable]="false"
        class="disabled-column"
      ></kendo-grid-column>
      <kendo-grid-column
        field="branchCode"
        title="Branch Code"
        width="200"
        *ngIf="hiderow"
      >
        <ng-template
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="!isNew"
        >
          <input
            class="k-textbox k-adjust-width"
            [formControl]="formGroup.get(column.field)"
            maxlength="50"
            kendoTextBox
          />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="branchDescription" title="Branch" width="200">
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <input
            class="k-textbox k-adjust-width"
            [formControl]="formGroup.get(column.field)"
            maxlength="50"
            kendoTextBox
          />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="active" title="Active" width="50">
        <ng-template kendoGridCellTemplate let-column>
          <input type="checkbox" [checked]="column.active" disabled />
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <input type="checkbox" [formControl]="formGroup.get(column.field)" />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column title="Command" width="100">
        <ng-template
          kendoGridCellTemplate
          let-isNew="isNew"
          let-dataItem="dataItem"
        >
          <button kendoGridEditCommand [primary]="true" (click)="showfield()">
            Edit
          </button>
          <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
            Save
          </button>
          <button kendoGridCancelCommand>Cancel</button>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
</div></div>
